import React from 'react';
import '../css/LoadingComponent.css';

export default function LoadingComponent() {
  return (
    <div className='LoadingComponent'>
        <div className="loaderComponent" />
    </div>
  );
}